<template>
  <div class="filters_parent">
    <div class="mb-3 d-flex justify-content-between gap-3 min-width-custom">
      <!-- Filters -->
      <div class="d-flex gap-3">
        <!-- Rows Search -->
        <div class="table_search d-flex justify-content-end align-items-center">
          <div class="d-flex gap-2 align-items-center ms-auto">
            <label for="table-complete-search" class="col-form-label"
              >Search:</label
            >
            <input
              id="table-complete-search"
              type="text"
              class="form-control form-control-sm"
              v-model="filterQuery"
              @input="$emit('search', filterQuery)"
            />
          </div>
        </div>
        <!-- Status Filter -->
        <div v-if="showStatusFilter">
          <select
            v-model="filterStatus"
            @change="handleStatusFilter"
            class="form-select form-select-sm"
          >
            <option value="">All Status</option>
            <option
              v-for="status in tableObj.allStatusLables"
              :key="status"
              :value="status"
            >
              {{ status }}
            </option>
          </select>
        </div>

        <!-- Category Filter -->
        <div v-if="showCategoryFilter">
          <select
            v-model="filterCategory"
            @change="handleCategoryFilter($event)"
            class="form-select form-select-sm"
          >
            <option value="">All Categories</option>
            <option
              v-for="cat in tableObj.categories"
              :key="cat._id"
              :value="cat._id"
            >
              {{ cat.title || cat }}
            </option>
          </select>
        </div>
        <!-- feature Filter -->
        <div v-if="showFeaturedFilter">
          <select
            v-model="filterCategory"
            @change="(e) => $emit('featuredFilter', e.target.value)"
            class="form-select form-select-sm"
          >
            <option value="">All Categories</option>
            <option
              v-for="(cat, index) in tableObj.categories"
              :key="index"
              :value="cat"
            >
              {{ cat }}
            </option>
          </select>
        </div>

        <!-- Priority Filter -->
        <div v-if="showPriorityFilter">
          <select
            v-model="filterPriority"
            @change="handlePriorityFilter"
            class="form-select form-select-sm"
          >
            <option value="">All Priority</option>
            <option
              v-for="priority in tableObj.allPriorityLables"
              :key="priority"
              :value="priority"
            >
              {{ priority }}
            </option>
          </select>
        </div>

        <!-- Reset Button -->
        <div v-if="showResetFilter" class="d-flex align-items-end">
          <button class="btn btn-secondary btn-sm" @click="handleResetFilters">
            Reset
          </button>
        </div>
      </div>

      <!-- Export Buttons -->
      <div class="d-flex gap-2">
        <button class="btn btn-primary btn-sm" @click="exportJSON">
          Export JSON
        </button>
        <button class="btn btn-success btn-sm" @click="exportCSV">
          Export CSV
        </button>
        <button class="btn btn-warning btn-sm" @click="exportExcel">
          Export Excel
        </button>
      </div>
    </div>
  </div>
  <Card1
    colClass="col-sm-12"
    cardhaderClass="pb-0 pb-0 card-no-border"
    pre="f-m-light mt-1"
    :title="title"
    span="true"
    :spanClass="desc"
  >
    <div class="table-responsive data-table theme-scrollbar zero-configuration">
      <div class="table_style">
        <table
          class="display table dataTable no-footer table-bordered fix-wrap"
          id="basic-1"
          :style="{ minWidth: table_width }"
        >
          <thead class="table-dark">
            <tr>
              <th scope="col" style="width: 70px">Sr No</th>
              <th
                v-for="(column, index) in columns"
                :key="index"
                :sortable="column.sortable"
                @click="sortTable(column.field)"
                :style="{
                  cursor: column.sortable ? 'pointer' : 'default',
                  width: column.width || 'auto',
                }"
              >
                {{ column.name }}
              </th>
              <th v-if="actions[0]" style="width: 260px" class="col-actions">
                Action
              </th>
            </tr>
          </thead>

          <!-- Loading State -->
          <tbody v-if="isLoading">
            <tr>
              <td
                :colspan="columns.length + (actions[0] ? 2 : 1)"
                class="text-center py-4"
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>

          <tbody v-else-if="get_rows().length">
            <tr v-for="(row, index) in get_rows()" :key="index">
              <td>
                <span class="serial_num">{{ index + 1 }}</span>
              </td>
              <td
                v-for="(column, colIndex) in columns"
                :key="colIndex"
                class="wrap-cell"
              >
                <!-- icon --> 
                <template v-if="column.field === 'icon'">
                  <i :class="getIconClasses(row[column.field])"></i>
                </template>

                <!-- FEATURED IMAGE -->
                <template v-else-if="column.field === 'featured_image'">
                  <img
                    v-if="row[column.field]"
                    :src="row[column.field]"
                    alt="feature image"
                    style="
                      width: 70px;
                      height: 40px;
                      object-fit: cover;
                      border-radius: 4px;
                      border: 6px solid #fff;
                    "
                  />
                  <span v-else class="text-muted">—</span>
                </template>

                <!-- VIEWS -->
                <template v-else-if="column.field === 'views'">
                  <div class="d-flex flex-column gap-1">
                    <small
                      ><i class="fas fa-eye me-1"></i
                      >{{ row[column.field].view_count }}</small
                    >
                    <small
                      ><i class="fas fa-heart me-1"></i
                      >{{ row[column.field].like_count }}</small
                    >
                    <small
                      ><i class="fas fa-share me-1"></i
                      >{{ row[column.field].share_count }}</small
                    >
                  </div>
                </template>

                <!-- is featured -->
                <template v-else-if="column.field === 'featured'">
                  <div class="d-flex flex-column gap-1">
                    <button
                      class="btn btn-sm"
                      style="cursor: pointer"
                      @click="isFeatured(row._id)"
                      :class="
                        row.is_featured ? 'btn-warning' : 'btn-outline-warning'
                      "
                      :disabled="permissionKey && !canUpdate(permissionKey)"
                    >
                      <i
                        :class="row.is_featured ? 'fas fa-star' : 'far fa-star'"
                      ></i>
                    </button>
                  </div>
                </template>

                <!-- category  -->
                <template v-else-if="column.field === 'category' &&  row[column.field]?.title ">
                  {{ row[column.field]?.title || "" }}
                </template>

                  <!-- category  -->
                <template v-else-if="column.field === 'date' || column.field === 'lastmod' || column.field === 'created_at'">
                  {{ formatDate(row[column.field])  }}
                </template>
                <!-- slot category status -->
                <template v-else-if="column.type === 'toggle_status'">
                  <button
                    class="btn btn-sm"
                    :class="
                      row.is_active ? 'btn-success' : 'btn-outline-danger'
                    "
                    @click="$emit('toggle-status', row._id, !row.is_active)"
                    :title="row.is_active ? 'Deactivate' : 'Activate'"
                    :disabled="permissionKey && !canUpdate(permissionKey)"
                  >
                    <i
                      :class="row.is_active ? 'fa fa-check' : 'fa fa-times'"
                    ></i>
                  </button>
                </template>

                <!-- badge -->
                <template v-else-if="column.type === 'badge'">
                  <span class="badge bg-info">
                    {{ row[column.field] }}
                  </span>
                </template>

                <template v-else>
                  <span
                    :class="{
                      published_tag: row[column.field] === 'published',
                      draft_tag: row[column.field] === 'draft',
                      scheduled_tag: row[column.field] === 'scheduled',
                      archived_tag: row[column.field] === 'archived',
                    }"
                  >
                    {{ row[column.field] }} 
                  </span>
                </template>
              </td>

              <td v-if="actions[0]" class="col-actions border-0">
                <div class="action_btns d-flex gap-2 justify-content-cneter">
                  <slot name="extra-actions" :row="row"></slot>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    style="cursor: pointer"
                    @click="viewRow(row)"
                    :disabled="permissionKey && !canView(permissionKey)"
                  >
                    <i class="icofont icofont-eye-alt"></i>
                  </button>
                  <button
                    v-if="row.isBlog"
                    class="btn btn-sm btn-outline-success"
                    style="cursor: pointer"
                    @click="editRow(row._id)"
                    :disabled="permissionKey && !canUpdate(permissionKey)"
                  >
                    <i class="icofont icofont-edit"></i>
                  </button>
                  <button
                    v-else
                    class="btn btn-sm btn-outline-success"
                    style="cursor: pointer"
                    @click="editRow(row)"
                    :disabled="permissionKey && !canUpdate(permissionKey)"
                  >
                    <i class="icofont icofont-edit"></i>
                  </button>

                  <div v-if="row.status">
                    <button
                      v-if="row.status === 'draft'"
                      @click="doPublish(row._id)"
                      class="btn btn-sm btn-outline-info"
                      title="Publish"
                      :disabled="permissionKey && !canUpdate(permissionKey)"
                    >
                      <i class="fas fa-paper-plane"></i>
                    </button>
                    <button
                      v-else-if="row.status === 'published'"
                      @click="doUnPublish(row._id)"
                      class="btn btn-sm btn-outline-warning"
                      title="Unpublish"
                      :disabled="permissionKey && !canUpdate(permissionKey)"
                    >
                      <i class="fas fa-pause"></i>
                    </button>
                  </div>

                  <button
                    class="btn btn-sm btn-outline-danger"
                    style="cursor: pointer"
                    @click="deleteRow(row._id)"
                    :disabled="permissionKey && !canDelete(permissionKey)"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>

          <!-- Empty State -->
          <tbody v-else="isLoading === 'false' && !get_rows().length">
            <tr>
              <td
                :colspan="columns.length + (actions[0] ? 2 : 1)"
                class="text-center py-5"
              >
                <i class="fas fa-book fa-3x text-muted mb-3"></i>
                <h5 class="text-muted">No records found</h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Card1>
</template>

<script lang="ts" setup>
import {
  ref,
  onMounted,
  watchEffect,
  defineAsyncComponent,
  defineProps,
  defineEmits,
  watch,
} from "vue";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { formatDate } from "@/composables/FormatDate";
import { usePermissions } from "@/composables/usePermissions";

const { canView, canUpdate, canDelete } = usePermissions();

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);
const emit = defineEmits([
  "isActive",
  "edit",
  "delete",
  "view",
  "toggleFeatured",
  "publish",
  "unPublish",
  "statusFilter",
  "categoryFilter",
  "priorityFilter",
  "resetFilters",
  "toggle-status",
  "featuredFilter",
  "search",
]);

let title = ref("");
const filterQuery = ref<string>("");
const allData = ref([]);
const props = defineProps(["tableObj", "title", "permissionKey"]);
const sortOrder = ref("asc");
const sortedColumn = ref(null);
const columns = ref([]);
const actions = ref([]);
const table_width = ref("auto");

const isLoading = ref(true);

// filters ref
const showStatusFilter = ref(false);
const showCategoryFilter = ref(false);
const showPriorityFilter = ref(false);
const showResetFilter = ref(false);
const filterStatus = ref("");
const filterCategory = ref("");
const filterPriority = ref("");
const showFeaturedFilter = ref(false);

onMounted(() => {
  allData.value = props.tableObj?.data; 
  columns.value = props.tableObj.columns;
  actions.value = props.tableObj.actions ? props.tableObj.actions : [];
  title.value = props.title;
  table_width.value = props.tableObj.table_width
    ? props.tableObj.table_width
    : "auto";
  isLoading.value = props.tableObj.loading;
  showCategoryFilter.value = props.tableObj.showCategoryFilter
    ? props.tableObj.showCategoryFilter
    : false;
  showPriorityFilter.value = props.tableObj.showPriorityFilter
    ? props.tableObj.showPriorityFilter
    : false;
  showFeaturedFilter.value = props.tableObj.showFeaturedFilter
    ? props.tableObj.showFeaturedFilter
    : false;
  showStatusFilter.value = props.tableObj.showStatusFilter
    ? props.tableObj.showStatusFilter
    : false;
  showResetFilter.value = props.tableObj.showResetFilter
    ? props.tableObj.showResetFilter
    : false;
});

// filters
watchEffect(() => {
  const source = props.tableObj?.data || [];
  let filtered = [...source]; 
  // Text search filter
  const query = filterQuery.value.toLowerCase();
  if (query) {
    filtered = filtered.filter((row) =>
      Object.values(row).some((val) =>
        val?.toString().toLowerCase().includes(query)
      )
    );
  }
  allData.value = filtered;
});

// Pagination
function get_rows() {
  return allData.value;
}

// Sorting
function sortTable(column: string) {
  if (sortedColumn.value === column)
    sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
  else (sortedColumn.value = column), (sortOrder.value = "asc");

  allData.value.sort((a, b) => {
    const aValue = a[column];
    const bValue = b[column];
    if (aValue < bValue) return sortOrder.value === "asc" ? -1 : 1;
    if (aValue > bValue) return sortOrder.value === "asc" ? 1 : -1;
    return 0;
  });
}

// table actions
function editRow(row) {
  emit("edit", row);
}
function viewRow(row) {
  emit("view", row);
}
function deleteRow(index) {
  emit("delete", index);
}

function isFeatured(index) {
  emit("toggleFeatured", index);
}

function doPublish(index) {
  emit("publish", index);
}
function doUnPublish(index) {
  emit("unPublish", index);
}

function handleStatusFilter() {
  emit("statusFilter", filterStatus.value);
}
function handlePriorityFilter() {
  emit("priorityFilter", filterPriority.value);
}
function handleResetFilters() {
  filterQuery.value = "";
  filterStatus.value = "";
  filterPriority.value = "";
  filterCategory.value = "";
  emit("resetFilters");
}

function handleCategoryFilter(event) {
  const id = event.target.value; // extract ID
  emit("categoryFilter", id); // emit ID to parent
}

watch(
  () => props.tableObj.loading,
  (newValue) => {
    isLoading.value = newValue;
  },
  { immediate: true }
);

// icon convertor
function getIconClasses(icon: any) {
  if (!icon) return ["fa-regular", "fa-circle-question"]; // null/empty

  // If string: "fa-solid fa-house"
  if (typeof icon === "string") {
    const parts = icon.split(" ");
    // return [getFaPrefix(icon), parts[1] || ""];
  }

  // If object: { prefix: "fa-brands", iconName: "fa-react" }
  if (typeof icon === "object") {
    return [icon.prefix || "fas", icon.iconName || ""];
  }

  return ["fa-regular", "fa-circle-question"]; // fallback
}


// Export
function exportJSON() {
  const blob = new Blob([JSON.stringify(allData.value, null, 2)], {
    type: "application/json",
  });
  saveAs(blob, "table-data.json");
}
function exportCSV() {
  const ws = XLSX.utils.json_to_sheet(allData.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, "table-data.csv");
}
function exportExcel() {
  const ws = XLSX.utils.json_to_sheet(allData.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, "table-data.xlsx");
}
</script>

<style scoped>
.table_style {
  overflow-x: auto;
  scrollbar-width: thin;
}

.table_search input {
  width: 300px;
}

.table,
.table th,
.table td,
tr {
  border: none !important;
}
table {
  box-shadow: 0.125rem 0.125rem 0.125rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.table tbody tr:nth-child(even) {
  background-color: #f0f7f8;
}
.table tbody tr:hover {
  background-color: #d7e4e6;
}
.serial_num {
  background-color: #ff6150;
  padding: 0.44em 0.7em;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  line-height: 100%;
}
.published_tag {
  background: #28a745;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  text-transform: capitalize;
}

.draft_tag {
  background: #ffc107;
  color: #000000;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  text-transform: capitalize;
}

.scheduled_tag {
  background: #17a2b8;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  text-transform: capitalize;
}

.archived_tag {
  background: #dc3545;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  text-transform: capitalize;
}
.min-width-custom {
  min-width: max-content;
}
.filters_parent {
  overflow-x: auto;
}
</style>
